import { Status } from "../types/models";

const DEFAULT_AFTER_PAYMENT_STATUS: Status = Status.PAID;

const PROVIDER_AFTER_PAYMENT_STATUS: Record<string, Status> = {
  Telemach: Status.PAID,
  Vodovod: Status.PAID,
  Elektroprivreda: Status.PAID,
  Toplane: Status.PAID,
  Oki: Status.PAID,
  Rad: Status.PAID,
  BhTelecom: Status.PAID,
  BhTelecomEmail: Status.COMPLETED,
};

const getAfterPaymentStatus = (providerName: string): Status => PROVIDER_AFTER_PAYMENT_STATUS[providerName] ?? DEFAULT_AFTER_PAYMENT_STATUS;

export { DEFAULT_AFTER_PAYMENT_STATUS, PROVIDER_AFTER_PAYMENT_STATUS, getAfterPaymentStatus };
